<template>
  <span>
    <v-slide-y-transition>
      <span>
        {{ textoMostrado }}
      </span>
    </v-slide-y-transition>

    <v-btn
      v-if="elTextoEsMayor"
      class="mb-1"
      text
      x-small
      color="blue"
      @click="cambiarCantidadCaracteres"
    >
      {{ textoBoton }}
    </v-btn>
  </span>
</template>

<script>
export default {
  name: 'CortarTextos',
  props: {
    texto: {
      type: String,
      required: true,
    },
    cantidadCaracteres: {
      type: Number,
      default: 140,
    },
  },
  data() {
    return {
      caracteresVisibles: this.cantidadCaracteres,
    };
  },
  computed: {
    elTextoEsMayor() {
      return this.texto.length > this.cantidadCaracteres;
    },
    textoBoton() {
      return this.caracteresVisibles === this.cantidadCaracteres
        ? 'Mostrar más'
        : 'Mostrar menos';
    },
    textoMostrado() {
      if (this.texto.length <= this.caracteresVisibles) {
        return this.texto;
      }
      return `${this.texto.substr(0, this.caracteresVisibles)}…`;
    },
  },
  methods: {
    cambiarCantidadCaracteres() {
      this.caracteresVisibles = this.caracteresVisibles === this.cantidadCaracteres
        ? this.texto.length
        : this.cantidadCaracteres;
    },
  },
};
</script>

<style lang="scss">
</style>
